const MATTERTAG_SAMPLES = [
  "https://my.matterport.com/show/?m=Lit1SmtizJT&brand=0",
];
export default MATTERTAG_SAMPLES;
